module.exports = __webpack_public_path__ + "static/img/big_zero.45d99fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/big_zero.png
// module id = vsJP
// module chunks = 3